<p>product-configuration works!</p>
<!--productConfiguration-->
<div>
  <!--OuterFrame-->
  <app-outer-frame-product-configuration></app-outer-frame-product-configuration>
</div>

